import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "fa"
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: "#e93751",
        secondary: "#00a7bc"
      }
    }
  }
});
